import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/pricingParam/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/pricingParam/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/pricingParam/updateById', data)
}

// 修改
export function updateStatusById (data) {
  return request.post('/business/pricingParam/updateStatusById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/pricingParam/delete/${id}`)
}

// 根据定价配置ID查询
export function findListByPricePramId (params) {
  return request.get(`/business/pricingDetail/findListByPricePramId`, {params})
}
// 根据ID修改配置
export function updatePricingDetailById (data) {
  return request.post('/business/pricingDetail/create', data)
}